import NotFound from './container/NotFoundContainer';

export default NotFound;
